<div class="d-flex justify-content-between align-items-center my-3 flex-wrap">
  <div class="fw-semibold text-secondary fs-6 mb-2 mb-md-0">
    {{ habilitarBotoesExtras ? 'Tabela de Cargos' : 'Tabela de Domínios' }}
  </div>

  <div class="d-flex gap-2 flex-wrap align-items-center" *ngIf="flatNodes.length">
    <span class="fw-semibold text-secondary small mb-2 mb-md-0 me-2">Ações:</span>

    <ng-container *ngFor="let acao of acoesTabela">
      <ng-container *ngIf="acao.habilitarBotoesExtras">
        <button nz-button type="button" [nzType]="acao.nzType" class="rounded-pill" (click)="acao.callback()" nz-tooltip
          [nzTooltipTitle]="acao.tooltip">
          <span nz-icon [nzType]="acao.icon" nzTheme="outline"></span>
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>

<div class="d-flex flex-column page-content border border-radius w-100 mb-5">
  <nz-table [nzData]="flatNodes" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
    [nzScroll]="{ x: 'fit-content', y: '800px' }" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate">
    <!-- (nzQueryParams)="sort($event)" -->
    <thead>
      <tr>
        <th nzWidth="50px" class="text-center"></th>
        <th nzWidth="50px" class="text-center">
          <!-- <input type="checkbox" [checked]="selectedIds.size > 0 && selectedIds.size === flatNodes.length"
            (change)="toggleSelectAll($event)" /> -->
        </th>
        <th nzWidth="300px" nzColumnKey="cargoReferencia">Cargo Referência</th>
        <th nzWidth="150px" nzColumnKey="tipoEntidade">Tipo de Entidade</th>
        <th nzWidth="150px" nzColumnKey="subTipo">SubTipo</th>
        <!-- <ng-container *ngIf="tipoOrgao()">
          <th nzWidth="150px" nzColumnKey="especificacaoSubTipoEntidade">Tipo de Órgão</th>
        </ng-container> -->
        <th nzWidth="150px">Ações</th>
      </tr>
    </thead>

    <tbody cdkDropList [cdkDropListData]="flatNodes" (cdkDropListDropped)="onDrop($event)">
      <tr *ngIf="formItem" class="bg-light border-top border-bottom">
        <td class="ant-table-cell" colspan="6">
          <form [formGroup]="formItem" class="col-12 py-2">
            <div class="w-100 mb-2" *ngIf="(modoInclusao === 'filho' || (modoEdicao && itemPai)) && itemPai">
              <span class="text-muted small">
                Subordinado a: <strong>{{ itemPai?.nomeCargoReferencia }}</strong>
              </span>
            </div>

            <div class="row g-3">
              <div class="col">
                <label class="form-label required">Cargo Referência</label>
                <nz-select formControlName="cargoReferencia" nzShowSearch nzAllowClear nzSize="large"
                  nzPlaceHolder="Cargo Referência" [compareWith]="compareFn">
                  <nz-option *ngFor="let item of cargoDisponivel" [nzValue]="item"
                    [nzLabel]="item.nomeCargoReferencia" />
                </nz-select>
              </div>
            </div>
          <div class="row row-cols-sm-3 g-3 mt-1">
              <div class="col">
                <label class="form-label required">Tipo de Entidade</label>
                <nz-select formControlName="tipoEntidade" nzShowSearch nzAllowClear nzSize="large"
                  nzPlaceHolder="Tipo de Entidade" [compareWith]="compareFn">
                  <nz-option *ngFor="let item of tipoEntidadeList" [nzValue]="item" [nzLabel]="item.nomeTipoEntidade" />
                </nz-select>
              </div>

              <div class="col">
                <label class="form-label required">SubTipo</label>
                <nz-select formControlName="subTipo" nzShowSearch nzAllowClear nzSize="large" nzPlaceHolder="SubTipo"
                  [compareWith]="compareFn">
                  <nz-option *ngFor="let item of subTipoList" [nzValue]="item" [nzLabel]="item.nomeSubTipoEntidade" />
                </nz-select>
              </div>

              <!-- <div class="col" *ngIf="tipoOrgao()">
                <label for="especificacaoSubTipoEntidadeId" class="form-label">Tipo de Órgão</label>
                <nz-select formControlName="especificacaoSubTipoEntidadeId" nzShowSearch nzAllowClear nzSize="large"
                  nzPlaceHolder="Pesquise o tipo de Órgão" [compareWith]="compareFn">
                  <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of especializacaoSubtipoList" />
                </nz-select>
              </div> -->

              <div class="col-auto d-flex align-items-end gap-2">
                <button nz-button nzType="primary" type="button" nzSize="large"
                  class="d-flex justify-content-center fw-semibold rounded-2 fs-6" (click)="confirmarNovoItem()"
                  [disabled]="!formItem.valid">
                  {{ modoEdicao ? 'Editar' : 'Salvar' }}
                </button>

                <ng-container *ngIf="!modoEdicao">
                  <button nz-button nzType="default" type="button" nzSize="large"
                    class="d-flex justify-content-center fw-semibold rounded-2 fs-6"
                    (click)="limparForm()">Limpar</button>
                </ng-container>

                <button nz-button nzType="default" type="button" nzSize="large"
                  class="d-flex justify-content-center fw-semibold rounded-2 fs-6"
                  (click)="cancelarNovoItem()">Cancelar</button>
              </div>
            </div>
          </form>
        </td>
      </tr>

      <tr *ngFor="let item of flatNodes; trackBy: trackById" cdkDrag [cdkDragData]="item" [class.text-danger]="item.nodeRef?.dataInativo"
        [class.selected]="selectedId === item.id" [ngClass]="'nivel-' + item.nivel" (mouseenter)="hoveredId = item.id"
        (mouseleave)="hoveredId = null" (click)="selectRow(item.id)" class="draggable-row">

        <td class="ant-table-cell icon-float-cell">
          <span class="drag-icon-float" nz-icon nzType="menu" nzTooltipTitle="Arraste para mover" nz-tooltip></span>
        </td>

        <td class="ant-table-cell text-center">
          <input type="checkbox" [checked]="selectedIds.has(item.id)" (change)="onCheck(item.id, $event)" />
        </td>

        <!-- <td class="text-center ant-table-cell">
          <ng-container *ngIf="item.nivel === 0">
            <button *ngIf="item.nodeRef.children?.length" nz-button nzSize="small"
              (click)="toggleExpand(item.nodeRef); $event.stopPropagation()">
              <span nz-icon [nzType]="iconeExpandido(item)" nzTheme="outline" [nzTooltipTitle]="tooltipExpandido(item)"
                nz-tooltip></span>
            </button>
          </ng-container>
        </td> -->

        <td class="ant-table-cell" [ngStyle]="{ 'padding-left.px': item.nivel > 0 ? (item.nivel + 1) * 12 : 0 }">
          <!-- <span *ngIf="item.nivel > 0" class="linha-filho me-2" [ngStyle]="{ 'padding-left.px': !item.nodeRef.children?.length ? item.nivel * 12 : 0 }"></span> -->
          <button *ngIf="item.nodeRef.children?.length" nz-button nzSize="small" type="button"
            (click)="toggleExpand(item.nodeRef); $event.stopPropagation()" class="me-2">
            <span nz-icon [nzType]="iconeExpandido(item)" nzTheme="outline" [nzTooltipTitle]="tooltipExpandido(item)"
              nz-tooltip></span>
          </button>
          <span [ngStyle]="{ 'padding-left.px': !item.nodeRef.children?.length ? (item.nivel + 1) * 6 : 0 }">
            {{ item.nomeCargoReferencia || '-' }}
          </span>
        </td>
        <td class="ant-table-cell">{{ item.nomeTipoEntidade || '-' }}</td>
        <td class="ant-table-cell">{{ item.nomeSubTipoEntidade || '-' }}</td>

        <!-- <ng-container *ngIf="tipoOrgao()">
          <td class="ant-table-cell">{{ item.nomeEspecificacaoSubTipoEntidade || '-' }}</td>
        </ng-container> -->

        <td class="ant-table-cell">
          <div class="d-flex align-items-center gap-3">
            <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu"
              (click)="setContextItem(item.nodeRef, $event)">
              <span nz-icon nzType="more" nzTheme="outline"></span>
            </button>

            <div class="d-flex flex-column gap-1">
              <button *ngIf="podeMoverAcima(item.nodeRef)" nz-button nzType="link" nzSize="small" type="button"
                (click)="moverAcima(item.nodeRef); $event.stopPropagation()" nz-tooltip
                nzTooltipTitle="Mover para cima">
                <span nz-icon nzType="arrow-up"></span>
              </button>
              <button *ngIf="podeMoverAbaixo(item.nodeRef)" nz-button nzType="link" nzSize="small" type="button"
                (click)="moverAbaixo(item.nodeRef); $event.stopPropagation()" nz-tooltip
                nzTooltipTitle="Mover para baixo">
                <span nz-icon nzType="arrow-down"></span>
              </button>
            </div>
          </div>

          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="iniciarNovoItem('filho', item.nodeRef); $event.stopPropagation()">
                <a>Incluir Subordinado</a>
              </li>
              <ng-container *ngIf="!item.nodeRef?.dataInativo">
                <li nz-menu-item (click)="editarItem(item.nodeRef); $event.stopPropagation()">
                  <a>Editar</a>
                </li>
                <li nz-menu-item (click)="alternarAtivacao(item.nodeRef); $event.stopPropagation()">
                  <ng-container *ngIf="!habilitarBotoesExtras">
                    {{ item.nodeRef.dataInativo ? 'Ativar na Hierarquia' : 'Inativar da Hierarquia' }}
                  </ng-container>
                  <ng-container *ngIf="habilitarBotoesExtras">
                    Deletar da Hierarquia
                  </ng-container>
                </li>
              </ng-container>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <ng-template #footerTemplate>
    <!-- <section class="d-flex justify-content-end w-100">
      <app-pagination [itemPorPagina]="10"></app-pagination>
    </section> -->
  </ng-template>
  <ng-template #semDadosTemplate>
    <div class="d-flex align-items-center justify-content-center" *ngIf="!flatNodes?.length">
      <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
    </div>
  </ng-template>
</div>
